import { css } from '@emotion/react';

export default $ => css`
  .lookup-list-field {
    width: 100%;
  }

  .lookup-list-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .lookup-list-search {
    flex: 1;
    min-width: 0;
  }

  .lookup-list-count {
    flex-shrink: 0;
    font-size: 0.8em;
    white-space: nowrap;
    margin-left: auto;
  }

  .lookup-list-items {
    max-height: 320px;
    overflow-y: auto;
    border: 1px solid ${$.cardBorderColor ?? '#dee2e6'};
    border-radius: 6px;
  }

  .lookup-list-group-label {
    padding: 6px 12px;
    font-size: 0.75em;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: ${$.gray500 ?? '#6c757d'};
    background: ${$.gray100 ?? '#f8f9fa'};
    border-bottom: 1px solid ${$.cardBorderColor ?? '#dee2e6'};
    position: sticky;
    top: 0;
  }

  .lookup-list-item {
    padding: 8px 12px;
    border-bottom: 1px solid ${$.cardBorderColor ?? '#dee2e6'};
    transition: background-color 0.1s ease;

    &:last-child {
      border-bottom: none;
    }

    &:nth-of-type(even) {
      background: ${$.gray50 ?? 'rgba(0, 0, 0, 0.02)'};
    }

    &:hover {
      background: ${$.gray100 ?? '#f8f9fa'};
    }
  }
`;
